// Example: https://viacep.com.br/ws/01001000/json/
export const VIA_CEP_SERVICE_BASE_URL = 'https://viacep.com.br/ws'
